import { MUELLIF_SECIM_LISTESI } from "../constants/requestUrls";

import { postRequest } from "../request";

const MuellifSecimListesi = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  return postRequest({ url: MUELLIF_SECIM_LISTESI, data });
}

export default MuellifSecimListesi;